module.exports = __webpack_public_path__ + "static/media/avatarMen.a8860283.svg";